import { render } from "./SidebarDefault.vue?vue&type=template&id=b0dd53ca&scoped=true"
import script from "./SidebarDefault.vue?vue&type=script&lang=js"
export * from "./SidebarDefault.vue?vue&type=script&lang=js"

import "./SidebarDefault.vue?vue&type=style&index=0&id=b0dd53ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0dd53ca"]])

export default __exports__